//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_GK,
  ICON_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
  LIGHT_BG_GK,
  PRIMARY_BTN_GK,
  BOX_SHADOW_GK,
} from "../../utils/colors";

//IMPORTING FONT
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerSection from "../../components/BannerSection";
import { PiUsersThree } from "react-icons/pi";
import { MdOutlineWorkspacePremium } from "react-icons/md";
import { FaRegCreditCard } from "react-icons/fa6";
import { TbMedicalCross } from "react-icons/tb";
import { IoSchoolOutline } from "react-icons/io5";
import { MdOutlineLocalPharmacy } from "react-icons/md";
import { TbBeach } from "react-icons/tb";
import LogoKaGk from "../../assets/icons/logo-ka-gk.svg";
import { LuHandshake } from "react-icons/lu";
import Values from "../../components/Values";
import FAQ from "../../components/FAQ";
import LinkedinCall from "../../components/LinkedinCall";
import FooterBar from "../../components/FooterBar";
import { RiQuestionLine } from "react-icons/ri";
import CustomButton from "../../components/CustomButton";
import JobCards from "../../components/JobCards";
import Testimony from "../../components/Testimony";
import TrabalheGrupo from "../../assets/images/trabalhe-conosco-grupo.webp";
import "./TrabalheConosco.css";

export default function TrabalheConosco() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const trabalheConoscoQuestions = [
    {
      id: 0,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          1. Quais áreas o Grupo Krause costuma contratar?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Atuamos em diversas frentes, como atendimento ao cliente,
          administração, vendas, serviços funerários, cemitério e áreas de
          apoio. Nossas vagas abrangem tanto funções operacionais quanto
          administrativas e estratégicas.
        </p>
      ),
    },
    {
      id: 1,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          2. É necessário ter experiência no setor funerário?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Não necessariamente. Valorizamos experiência, mas também investimos em
          treinamentos internos para que novos colaboradores aprendam nossos
          padrões de atendimento e conduta. O mais importante é ter empatia,
          comprometimento e vontade de aprender.
        </p>
      ),
    },
    {
      id: 2,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          3. Como saberei se meu currículo foi aprovado?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Após análise, nossa equipe de RH entra em contato por e-mail ou
          telefone para informar sobre o andamento do processo e, se for o caso,
          agendar entrevistas.
        </p>
      ),
    },
    {
      id: 3,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          4. Como funciona o processo seletivo?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Geralmente, iniciamos com triagem de currículos, seguida por
          entrevistas presenciais ou online. Todo o processo é conduzido com
          respeito e transparência.
        </p>
      ),
    },
    {
      id: 4,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          5. O Grupo Krause oferece oportunidades de crescimento?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Sim. Incentivamos o desenvolvimento profissional por meio de
          treinamentos, cursos e oportunidades internas de promoção.
        </p>
      ),
    },
    {
      id: 5,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          6. Posso me candidatar para mais de uma vaga?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Sim. Caso seu perfil se encaixe em diferentes áreas, você pode se
          candidatar a mais de uma vaga, informando seu interesse no formulário
          ou e-mail de inscrição.
        </p>
      ),
    },
    {
      id: 6,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          7. Como é o ambiente de trabalho no Grupo Krause?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Temos um ambiente colaborativo, ético e humanizado, onde todos
          trabalham com respeito e empatia. Prezamos pela valorização das
          pessoas e pelo cuidado mútuo.
        </p>
      ),
    },
    {
      id: 7,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          8. Quais são os valores que o Grupo Krause mais valoriza nos
          colaboradores?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Empatia, ética, comprometimento, responsabilidade e desejo de servir
          com excelência. Nosso trabalho exige respeito e atenção a cada
          detalhe.
        </p>
      ),
    },
    {
      id: 8,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          9. Como posso me preparar para a entrevista no Grupo Krause?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Seja você mesmo(a), vista-se adequadamente, traga documentos
          atualizados e demonstre interesse em nossa missão e valores. Conhecer
          nossa história e nossos serviços é um diferencial.
        </p>
      ),
    },
  ];

  return (
    <div className="TrabalheConosco">
      <DynamicTitle
        pageTitle="Grupo Krause - Trabalhe Conosco"
        pageMeta="Grupo Krause"
        pageContent="Atuamos com excelência nos serviços funerários, planos e cuidados com cemitérios, sempre com foco em quem mais importa: as pessoas."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <PiUsersThree
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"HÁ MAIS DE 100 ANOS VALORIZANDO A VIDA"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={"Tradição, respeito e oportunidades para crescer."}
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={TrabalheGrupo}
        bannerBGmobile={TrabalheGrupo}
      />
      <Container>
        <Row>
          <Col className="trabalhe-conosco-text-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              No Grupo Krause, valorizamos cada história. Aqui, cada colaborador
              tem um papel essencial na construção de um atendimento humanizado,
              ético e acolhedor. Atuamos com excelência nos serviços funerários,
              planos e cuidados com cemitérios, sempre com foco em quem mais
              importa: as pessoas.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="trabalhe-conosco-text-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Acreditamos que um bom ambiente de trabalho é feito de respeito,
              aprendizado constante e reconhecimento. Por isso, promovemos uma
              cultura colaborativa, onde todos crescem juntos e são incentivados
              a se desenvolverem profissionalmente e pessoalmente. Se você busca
              um lugar onde seu trabalho tenha propósito e impacto real, o seu
              lugar pode ser aqui.
            </p>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className="trabalhe-conosco-first-col">
            <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
              <MdOutlineWorkspacePremium
                style={{ color: ICON_COLOR_GK }}
                className="trabalhe-conosco-icon"
              />
              BENEFÍCIOS DE TRABALHAR CONOSCO
            </h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="trabalhe-conosco-card">
              <div
                className="trabalhe-conosco-circle"
                style={{ background: LIGHT_BG_GK }}
              >
                <FaRegCreditCard
                  style={{ color: ICON_COLOR_GK }}
                  className="trabalhe-conosco-circle-icon"
                />
              </div>
              <p style={{ color: TEXT_COLOR, fontSize: SUB_TITLE_SIZE }}>
                Cartão Multibenefícios
              </p>
            </div>
          </Col>
          <Col>
            <div className="trabalhe-conosco-card">
              <div
                className="trabalhe-conosco-circle"
                style={{ background: LIGHT_BG_GK }}
              >
                <img
                  src={LogoKaGk}
                  alt="ícone assistencial"
                  className="trabalhe-conosco-icon-ka"
                />
              </div>
              <p style={{ color: TEXT_COLOR, fontSize: SUB_TITLE_SIZE }}>
                Plano Grupo Krause
              </p>
            </div>
          </Col>
          <Col>
            <div className="trabalhe-conosco-card">
              <div
                className="trabalhe-conosco-circle"
                style={{ background: LIGHT_BG_GK }}
              >
                <TbMedicalCross
                  style={{ color: ICON_COLOR_GK }}
                  className="trabalhe-conosco-circle-icon"
                />
              </div>
              <p style={{ color: TEXT_COLOR, fontSize: SUB_TITLE_SIZE }}>
                Plano de Saúde
              </p>
            </div>
          </Col>
          <Col>
            <div className="trabalhe-conosco-card">
              <div
                className="trabalhe-conosco-circle"
                style={{ background: LIGHT_BG_GK }}
              >
                <IoSchoolOutline
                  style={{ color: ICON_COLOR_GK }}
                  className="trabalhe-conosco-circle-icon"
                />
              </div>
              <p style={{ color: TEXT_COLOR, fontSize: SUB_TITLE_SIZE }}>
                Auxílio Educação
              </p>
            </div>
          </Col>
          <Col>
            <div className="trabalhe-conosco-card">
              <div
                className="trabalhe-conosco-circle"
                style={{ background: LIGHT_BG_GK }}
              >
                <MdOutlineLocalPharmacy
                  style={{ color: ICON_COLOR_GK }}
                  className="trabalhe-conosco-circle-icon"
                />
              </div>
              <p style={{ color: TEXT_COLOR, fontSize: SUB_TITLE_SIZE }}>
                Convênio Farmácia
              </p>
            </div>
          </Col>
          <Col>
            <div className="trabalhe-conosco-card">
              <div
                className="trabalhe-conosco-circle"
                style={{ background: LIGHT_BG_GK }}
              >
                <TbBeach
                  style={{ color: ICON_COLOR_GK }}
                  className="trabalhe-conosco-circle-icon"
                />
              </div>
              <p style={{ color: TEXT_COLOR, fontSize: SUB_TITLE_SIZE }}>
                Day off Aniversário
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className="trabalhe-conosco-col">
            <LuHandshake
              style={{ color: ICON_COLOR_GK }}
              className="trabalhe-conosco-icon"
            />
            <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
              CONFIRA NOSSAS VAGAS
            </h2>
          </Col>
        </Row>
      </Container>
      <JobCards
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        btnColor={PRIMARY_BTN_GK}
        shadowColor={BOX_SHADOW_GK}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <Container>
        <Row>
          <Col className="trabalhe-conosco-second-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Não encontrou a vaga desejada? Cadastre seu currículo em nosso
              banco de talentos e aumente as suas chances de uma candidatura em
              nossos processos seletivos. Gostamos de conhecer quem deseja
              crescer com propósito.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="trabalhe-conosco-third-col">
            <CustomButton
              className="primary-btn"
              variant="primary"
              href="https://grupokrause.vagas.solides.com.br/"
              rel="noopener noreferrer"
              target="_blank"
              icon=""
              content="CADASTRAR-SE"
              backgroundColor={PRIMARY_BTN_GK}
              fontFamily="Unageo-Bold"
              fontColor={WHITE}
              fontSize={20}
              width={260}
              borderColor={PRIMARY_BTN_GK}
              disabled={false}
            />
          </Col>
        </Row>
        <Row>
          <Testimony
            white={WHITE}
            titleColor={TITLE_COLOR_GK}
            textColor={TEXT_COLOR}
            titleSize={TITLE_SIZE}
            subTitleSize={SUB_TITLE_SIZE}
            textSize={TEXT_SIZE}
            subTextSize={SUB_TEXT_SIZE}
          />
        </Row>
      </Container>
      <Values
        white={WHITE}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_GK}
      />
      <FAQ
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        iconTitle={
          <RiQuestionLine
            style={{ color: ICON_COLOR_GK }}
            className="faq-icon"
          />
        }
        titleContent="DÚVIDAS E PERGUNTAS"
        questionsContent={trabalheConoscoQuestions}
      />
      <LinkedinCall
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
